import { InvoiceStatus } from '@rematter/frontend-lib-api-client/grpc/finance/v1/domain_pb';
import { InvoicePaidEvent } from '@rematter/frontend-lib-api-client/grpc/finance/v1/invoice_events_pb';
import { Col, FieldDisplay, StatusTransition } from '@rematter/ui-web';

import { invoiceStatusLabels, invoiceTypeLabels } from '../enumLabels';

import { useTranslations } from '@/finance/i18n/useTranslations';

type InvoicePaidDetailProps = {
  event: InvoicePaidEvent;
};

export const InvoicePaidDetail = ({ event }: InvoicePaidDetailProps) => {
  const t = useTranslations();
  const invoice = event.invoice;
  const previousStatus = event.previousStatus;

  if (!invoice) {
    return (
      <Col className="@InvoicePaidDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  const formatAmount = () => {
    if (!invoice.amount) return 'N/A';
    const value = Number(invoice.amount.amount) / 100;
    return `${invoice.amount.currency} ${value.toFixed(2)}`;
  };

  return (
    <Col className="@InvoicePaidDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.invoice}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay
            label="Document Number"
            value={invoice.documentNumber}
          />
          <FieldDisplay label="Type" value={invoiceTypeLabels[invoice.type]} />
          <FieldDisplay label="Amount" value={formatAmount()} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.statusChange}
        </span>
        <StatusTransition
          previousStatus={invoiceStatusLabels[previousStatus]}
          newStatus={invoiceStatusLabels[InvoiceStatus.PAID]}
        />
      </Col>
    </Col>
  );
};
